<template>
	<div class="side_navigation">
		<div class="scroller">
			<el-menu
				:default-active="activeIndex"
				:unique-opened="true"
				@select="handleSelect"
			>
				<!-- 用户管理 -->
				<el-submenu index="1">
					<template slot="title">
						<span>用户管理</span>
					</template>
					<el-menu-item index="1-1">账户续费检查</el-menu-item>
				</el-submenu>
				<!-- 用户管理 end -->
				
				<!-- 训练师管理 -->
				<el-submenu index="2">
					<template slot="title">
						<span>训练师管理</span>
					</template>
					<el-menu-item index="2-1">训练师档案</el-menu-item>
				</el-submenu>
				<!-- 训练师管理 end -->
				
				<!-- 任务指标操作 -->
				<el-submenu index="3">
					<template slot="title">
						<span>任务指标操作</span>
					</template>
					<el-menu-item index="3-1">截止频率重测</el-menu-item>
				</el-submenu>
				<!-- 任务指标操作 end -->
			</el-menu>
		</div>

		<div class="ft">版权所有@ <a href="http://www.uflyvision.com/" target="_blank">科飞视觉</a></div>
	</div>
</template>

<script>
	import { mapState } from "vuex"
	
	const PATH_LIST = [
		{
			index: "1-1",
			path: "/index/operation_manage/user_account_renewal_check"
		}, {
			index: "2-1",
			path: "/index/operation_manage/trainer_master"
		}, {
			index: "3-1",
			path: "/index/operation_manage/task_cutOff"
		}
	];
	export default {
		mounted() {
			this.initActiveIndex();
		},
		data () {
			return {
				activeIndex: ""
			}
		},
		computed: {
			...mapState([
				'authInfo'
			])
		},
		methods: {
			initActiveIndex () {
				const that = this;
				var _path = this.$route.path,
					_category = this.authInfo.ucategory;
				if (_category != 1) {
					that.$router.replace({
						path: '/index'
					});
					return false;
				}
				PATH_LIST.forEach((v) => {
					v.path == _path && (that.activeIndex = v.index);
				});
			},
			handleSelect (key) {
				var _path,
					_currentPath = this.$route.path;
				PATH_LIST.forEach((v) => {
					v.index == key && (_path = v.path);
				});
				_currentPath != _path && this.$router.push({path: _path});
			}
		}
	}
</script>

<style>
	.operation_manage_page .side_navigation{ display: block;position: absolute;z-index: 99;width: 220px;height: 100%;top: 0;left: 0;padding-bottom: 48px;background: #fff; }
	.operation_manage_page .side_navigation:after{ content: "";display: block;position: absolute;width: 1px;height: 100%;top: 0;right: 0;background: #ccc; }
	.operation_manage_page .side_navigation .scroller{ display: block;width: 100%;height: 100%;overflow-y: auto; }
	.operation_manage_page .side_navigation .scroller::-webkit-scrollbar {display:none}
	.operation_manage_page .side_navigation .ft{ position: absolute;width: 100%;height: 48px;bottom: 0px;padding: 10px 15px;font-size: 12px;text-align: center;line-height: 28px; }
	.operation_manage_page .side_navigation .ft:before{ content: "";display: block;position: absolute;width: 100%;height: 1px;top: 0;left: 0;background: #ccc; }
	.operation_manage_page .side_navigation .ft a{ color: #30a5ff; }
	.operation_manage_page .side_navigation .ft a:hover{ text-decoration: underline; }
	
	.operation_manage_page .side_navigation .el-menu{ border-right: none; }
	.operation_manage_page .side_navigation .el-submenu{ margin-top: 5px;  }
	.operation_manage_page .side_navigation .el-submenu:first-child{ margin-top: 0; }
	.operation_manage_page .side_navigation .el-submenu__title{ height: 40px;background-color: #30a5ff;color: #fff;line-height: 40px; }
	.operation_manage_page .side_navigation .el-submenu__icon-arrow{ font-size: 18px;color: #fff; }
	.operation_manage_page .side_navigation .el-menu-item{ height: 40px;color: #30a5ff;line-height: 40px; }
	.operation_manage_page .side_navigation .el-menu-item.is-active{ background: #ecf5ff; }

</style>
